var icon = require('vue-svgicon')
icon.register({
  'ks-icon-sort-desc--off-white': {
    width: 128,
    height: 128,
    viewBox: '0 0 128 128',
    data: '<path pid="0" d="M88.48 51.79L64 27.31 39.52 51.79 32 44.21l32-32 32 32z"/>'
  }
})
